module.exports = __webpack_public_path__ + "static/media/alcogate-3.210bd42b.jpg";